import { render } from "./vue-ueditor-wrap.vue?vue&type=template&id=4a4fa9d9"
import script from "./vue-ueditor-wrap.vue?vue&type=script&lang=js"
export * from "./vue-ueditor-wrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ueditor/vue-ueditor-wrap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a4fa9d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a4fa9d9', __exports__)) {
    api.reload('4a4fa9d9', __exports__)
  }
  
  module.hot.accept("./vue-ueditor-wrap.vue?vue&type=template&id=4a4fa9d9", () => {
    api.rerender('4a4fa9d9', render)
  })

}


export default __exports__